import React from 'react';

const LeftArrowIcon = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 1024 1024"
  >
    <title />
    <g id="icomoon-ignore" />
    <path d="M701.126 37.807l-438.992 441.753q-35.894 30.37 0 60.74l438.992 441.753q30.37 35.894 60.74 0 35.894-30.37 0-60.74l-408.622-411.383 408.622-411.383q35.894-30.37 0-60.74-13.806-13.806-30.37-13.806t-30.37 13.806z" />
  </svg>
);

export default LeftArrowIcon;
